"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "useFormState", {
  enumerable: true,
  get: function get() {
    return _useFormState["default"];
  }
});
var _Form = _interopRequireDefault(require("./Form"));
var _useFormState = _interopRequireDefault(require("./hooks/useFormState"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = exports["default"] = _Form["default"];